module.exports = __webpack_public_path__ + "static/media/cats-logo-light.2b00c938.svg";